// extracted by mini-css-extract-plugin
export default {"list":"Catalog_list__9kVCk","card":"Catalog_card__5ZKgB","btns":"Catalog_btns__ZyNnb","button":"Catalog_button__mrmhN","loader":"Catalog_loader__HKmVE"};